import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ChatBubble.styled';
import { useFeature } from '../../../../../core/src/components/LaunchDarkly';

const ChatBubble = (props) => {
  const vhBigUiFeature = useFeature('vh-big-ui');
  return (
    <Styled.Bubble
      $vhBigUiFeature={vhBigUiFeature}
      chatType={props.chatType}
      feedbackText={props.feedbackText}
    >
      {props.children}
    </Styled.Bubble>
  );
};

ChatBubble.defaultPropTypes = {
  chatType: true,
};

ChatBubble.propTypes = {
  children: PropTypes.node.isRequired,
  chatType: PropTypes.string.isRequired,
  feedbackText: PropTypes.string,
};

export default ChatBubble;
